const updateResourceLink = (
    link,
    cusip,
    trpCode,
    replaceCusip,
    replaceTrpCode,
    replaceFundName,
    ticker
) => {
    if (replaceCusip) {
        return link + cusip;
    }
    if (replaceTrpCode) {
        return link.replace(
            'TRPCODE',
            {
                TRPB: 'BCG',
                TRPD: 'DGX'
            }[trpCode] || trpCode
        );
    }
    if (replaceFundName) {
        const linkFundName =
            {
                TCHP: 'blue-chip-growth-etf',
                TRBCX: 'blue-chip-growth-etf',
                TDVG: 'dividend-growth-etf',
                DGFT: 'dividend-growth-etf',
                TGRW: 'growth-stock-etf',
                TEQI: 'equity-income-etf',
                TSPA: 'equity-research-etf'
            }[ticker] || 'no-matching-etf-error';
        const resourceLink = `/financial-intermediary/us/en/investments/etfs/${linkFundName}.html#primary-holdings,no-description-provided-portfolio-tracking`;
        return resourceLink;
    }

    return link;
};

export default updateResourceLink;
